import { dcolors, yahooFin } from "corexxx";

export function DStockGrowthTable({ data }: { data: yahooFin.TStockInfo[] }) {
  // Group data by year and month
  const groupedData: Record<number, Record<number, number[]>> = {};
  data.forEach((item: any) => {
    const date = new Date(item.timestamp * 1000);
    const year = date.getFullYear();
    const month = date.getMonth();

    if (!groupedData[year]) {
      groupedData[year] = {};
    }
    if (!groupedData[year][month]) {
      groupedData[year][month] = [];
    }
    groupedData[year][month].push(item.pchange);
  });

  // Calculate sum of percentage changes for each year and month
  const years = Object.keys(groupedData)
    .map(Number)
    .sort((a, b) => a - b);
  return (
    <table
      style={{ borderCollapse: "collapse", width: "100%", textAlign: "center" }}
    >
      <thead>
        <tr>
          <th style={{ border: "1px solid #ddd", padding: "8px" }}>Year</th>
          {Array.from({ length: 12 }, (_, i) => (
            <th key={i} style={{ border: "1px solid #ddd", padding: "8px" }}>
              {new Date(0, i).toLocaleString("default", { month: "short" })}
            </th>
          ))}
          <th style={{ border: "1px solid #ddd", padding: "8px" }}>Total</th>
        </tr>
      </thead>
      <tbody>
        {years.map((year) => {
          const months = groupedData[year];
          const totalSum = Object.values(months)
            .flat()
            .reduce((sum, value) => sum + value, 0);

          return (
            <tr key={year}>
              <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                {year}
              </td>
              {Array.from({ length: 12 }, (_, i) => {
                const monthSum = (months[i] || []).reduce(
                  (sum, value) => sum + value,
                  0,
                );
                return (
                  <td
                    key={i}
                    style={{
                      border: "1px solid #ddd",
                      padding: "8px",
                      background: getColorForNumber(monthSum),
                    }}
                  >
                    {monthSum.toFixed(2)}
                  </td>
                );
              })}
              <td
                style={{
                  border: "1px solid #ddd",
                  padding: "8px",
                  fontWeight: "bold",
                  background: getColorForNumber(totalSum),
                }}
              >
                {totalSum.toFixed(2)}%
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}

const getColorForNumber = (num: number): string => {
  if (num > 4) return dcolors.pallets.green400;
  if (num > 1) return dcolors.pallets.green200;
  if (num > 0) return dcolors.pallets.green50;
  if (num < -4) return dcolors.pallets.red400;
  if (num < -1) return dcolors.pallets.red200;
  if (num < 0) return dcolors.pallets.red50;
  return "white"; // Default color for 0
};
